<template>
  <div class="floating-wrapper notif" id="floating-wrapper" :class="`${!isExpanded && multi ? 'shadow-notif' : ''}`">
    <div class="header-floating-notification">
      <div class="header-floating-notification-icon">
        <img src="../assets/icons/logo-notif.png" alt="">
        <span>Partai Perindo</span>
      </div>
      <div class="header-floating-notification-action">
        <span class="clear" @click="$emit('clearnotification')" v-if="isExpanded">Hapus Semua</span>
        <svg class="pointer" v-if="!multi || isExpanded" @click="handleExpand()" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.94091 11.0003L7.81991 8.87931C7.68329 8.73786 7.60769 8.54841 7.6094 8.35176C7.61111 8.15511 7.68999 7.967 7.82904 7.82795C7.9681 7.68889 8.15621 7.61001 8.35286 7.6083C8.5495 7.6066 8.73896 7.68219 8.88041 7.81881L11.0014 9.93981L13.1224 7.81881C13.1916 7.74718 13.2744 7.69004 13.3659 7.65073C13.4574 7.61143 13.5558 7.59074 13.6554 7.58987C13.7549 7.58901 13.8537 7.60798 13.9459 7.64569C14.038 7.6834 14.1218 7.73909 14.1922 7.80951C14.2626 7.87993 14.3183 7.96367 14.356 8.05584C14.3937 8.14802 14.4127 8.24678 14.4118 8.34636C14.411 8.44595 14.3903 8.54436 14.351 8.63586C14.3117 8.72737 14.2545 8.81012 14.1829 8.87931L12.0619 11.0003L14.1829 13.1213C14.2545 13.1905 14.3117 13.2733 14.351 13.3648C14.3903 13.4563 14.411 13.5547 14.4118 13.6543C14.4127 13.7538 14.3937 13.8526 14.356 13.9448C14.3183 14.0369 14.2626 14.1207 14.1922 14.1911C14.1218 14.2615 14.038 14.3172 13.9459 14.3549C13.8537 14.3926 13.7549 14.4116 13.6554 14.4107C13.5558 14.4099 13.4574 14.3892 13.3659 14.3499C13.2744 14.3106 13.1916 14.2534 13.1224 14.1818L11.0014 12.0608L8.88041 14.1818C8.73896 14.3184 8.5495 14.394 8.35286 14.3923C8.15621 14.3906 7.9681 14.3117 7.82904 14.1727C7.68999 14.0336 7.61111 13.8455 7.6094 13.6489C7.60769 13.4522 7.68329 13.2628 7.81991 13.1213L9.94091 11.0003Z" fill="#C71D23"/>
          <path d="M11 20C12.1819 20 13.3522 19.7672 14.4442 19.3149C15.5361 18.8626 16.5282 18.1997 17.364 17.364C18.1997 16.5282 18.8626 15.5361 19.3149 14.4442C19.7672 13.3522 20 12.1819 20 11C20 9.8181 19.7672 8.64778 19.3149 7.55585C18.8626 6.46392 18.1997 5.47177 17.364 4.63604C16.5282 3.80031 15.5361 3.13738 14.4442 2.68508C13.3522 2.23279 12.1819 2 11 2C8.61305 2 6.32387 2.94821 4.63604 4.63604C2.94821 6.32387 2 8.61305 2 11C2 13.3869 2.94821 15.6761 4.63604 17.364C6.32387 19.0518 8.61305 20 11 20ZM11 21.5C8.21523 21.5 5.54451 20.3938 3.57538 18.4246C1.60625 16.4555 0.5 13.7848 0.5 11C0.5 8.21523 1.60625 5.54451 3.57538 3.57538C5.54451 1.60625 8.21523 0.5 11 0.5C13.7848 0.5 16.4555 1.60625 18.4246 3.57538C20.3938 5.54451 21.5 8.21523 21.5 11C21.5 13.7848 20.3938 16.4555 18.4246 18.4246C16.4555 20.3938 13.7848 21.5 11 21.5Z" fill="#253D82"/>
        </svg>
        <svg class="pointer" @click="handleExpand()" v-if="multi && !isExpanded" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M22.5 11.25H21V5.25H9.75V3.75H21C21.3977 3.7504 21.779 3.90856 22.0602 4.18978C22.3414 4.471 22.4996 4.8523 22.5 5.25V11.25Z" fill="#253D82"/>
          <path d="M18.75 15H17.25V9H6V7.5H17.25C17.6477 7.5004 18.029 7.65856 18.3102 7.93978C18.5914 8.221 18.7496 8.6023 18.75 9V15Z" fill="#C71D23"/>
          <path d="M13.5 20.25H3C2.6023 20.2496 2.221 20.0914 1.93978 19.8102C1.65856 19.529 1.5004 19.1477 1.5 18.75V12.75C1.5004 12.3523 1.65856 11.971 1.93978 11.6898C2.221 11.4086 2.6023 11.2504 3 11.25H13.5C13.8977 11.2504 14.279 11.4086 14.5602 11.6898C14.8414 11.971 14.9996 12.3523 15 12.75V18.75C14.9996 19.1477 14.8414 19.529 14.5602 19.8102C14.279 20.0914 13.8977 20.2496 13.5 20.25ZM3 12.75V18.75H13.5007L13.5 12.75H3Z" fill="#253D82"/>
        </svg>
      </div>
    </div>
    <div class="scrollable">
      <slot></slot>
    </div>
  </div>
</template>
<script>

export default {
  name: 'FloatingNotificationWrapper',
  props: ['multi'],
  data () {
    return {
      isExpanded: false
    }
  },
  methods: {
    handleExpand () {
      if (!this.isExpanded && !this.multi) {
        return this.$emit('clearnotification')
      }

      this.isExpanded = !this.isExpanded

      const element = document.getElementById('floating-wrapper')
      element.style.maxHeight = this.isExpanded ? '700px' : '186px'
      element.style.transition = this.isExpanded ? 'max-height 0.3s ease-out' : 'max-height 0.3s ease-in'

      const scrollable = document.getElementsByClassName('scrollable')[0]
      scrollable.style.overflowY = this.isExpanded ? 'scroll' : 'hidden'

      this.$emit('onExpand', this.isExpanded)
    }
  }
}
</script>
<style scoped lang="scss">

.floating-wrapper {
  display: flex;
  flex-direction: column;
  // justify-content: flex-end;
  max-height: 186px;
  position: fixed;
  border-radius: 5px;
  top: 3em;
  transition: max-height .8s ease-in-out;
  z-index: 10;
  right: 3em;
  width: 360px;
  box-shadow: 0px 4px 16px rgba(33, 64, 154, 0.1);
  overflow: hidden;

  background-color: $white;
    @media only screen and (max-width: 600px) {
      right: 1em;
      bottom: 1em;
    }

  .header-floating-notification {
    display: flex;
    flex-direction: row;
    background-color: #CEDAFF;
    padding: 8px 12px;
    justify-content: space-between;

    .header-floating-notification-icon {
      display: flex;
      width: 50%;
      align-items: center;
      span {
        color: $blue;
        margin-left: 12px;
      }
    }
    .header-floating-notification-action {
      display: flex;
      width: 50%;
      justify-content: flex-end;
      align-items: center;
      span {
        color: $blue;
        margin-right: 1em;
        cursor: pointer;
      }
    }

  }
}

.shadow-notif {
  width: 360px;
  box-shadow:rgba(33, 64, 154, 0.1) 0px 5px, rgba(33, 64, 154, 0.1) 0px 10px;
    // rgba(0, 46, 170, 0.2) 0px 15px;
}

.clear {
  align-items: center;
  justify-content: center;
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 11px;
  letter-spacing: 0.01em;
}

.scrollable {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */

  &::-webkit-scrollbar {
    display: none;
  }

}

</style>
